import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { PropertyMatch } from '../../domain/models/property-share.model';

/** "Possible duplicate" card: staff either link the two properties or dismiss the match. */
@Component({
  selector: 'app-property-match-card',
  standalone: true,
  imports: [CommonModule, FormsModule, MatButtonModule, MatIconModule, MatRadioModule],
  templateUrl: './property-match-card.component.html',
  styleUrls: ['./property-match-card.component.css']
})
export class PropertyMatchCardComponent implements OnChanges {
  @Input({ required: true }) match!: PropertyMatch;
  @Input() newIsManagementCompany = false;
  /** Disables the buttons while the parent's request is in flight. */
  @Input() busy = false;
  @Output() link = new EventEmitter<{ newIsHome: boolean }>();
  @Output() notSame = new EventEmitter<void>();

  /** The home account carries the returns; default to the management-company side. */
  newIsHome = false;

  /** Only a new match resets the choice; a `busy` toggle must not flip it back. */
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['match']) return;
    this.newIsHome = this.match?.accountType === 2 ? false : this.newIsManagementCompany;
  }
}
